/*
 * シューズ比較LP
 * - 購入カードのバリアント選択(価格/在庫/ボタン状態の同期、未選択時のエラーとフォーカス移動)
 * - 用途セレクターによる推奨商品の選択状態
 * - Sticky Purchase Bar(選択商品の反映、最終CTAとの表示競合回避)
 *
 * カート追加そのものはテーマの <product-form> に委ねる。ここでは hidden の name="id" を
 * 書き戻すことと、未選択時に送信を止めることだけを担う。
 * 計測イベントは実装しない(2026-08-06 決定)。将来の追加に備え data-* 属性のみ用意する。
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-shoes-compare]');
  if (!root) return;

  var boxes = [];
  var state = { side: null };

  function yen(cents) {
    try {
      return '¥' + Number(cents / 100).toLocaleString('ja-JP');
    } catch (e) {
      return '¥' + Math.round(cents / 100);
    }
  }

  /* ---------------- 購入カード ---------------- */

  function createBox(el) {
    var json = el.querySelector('[data-shoes-variants]');
    var variants = [];
    try {
      variants = JSON.parse(json.textContent);
    } catch (e) {
      variants = [];
    }

    var box = {
      el: el,
      side: el.getAttribute('data-side'),
      title: el.getAttribute('data-product-title') || '',
      isPreorder: el.getAttribute('data-preorder') === 'true',
      variants: variants,
      fieldsets: Array.prototype.slice.call(el.querySelectorAll('[data-shoes-option]')),
      idInput: el.querySelector('[data-shoes-variant-id]'),
      priceEl: el.querySelector('[data-shoes-price-value]'),
      stockEl: el.querySelector('[data-shoes-stock]'),
      submitEl: el.querySelector('[data-shoes-submit]'),
      labelEl: el.querySelector('[data-shoes-submit-label]'),
      errorEl: el.querySelector('[data-shoes-error]'),
      form: el.querySelector('form'),
      imgEl: el.querySelector('[data-shoes-buybox-img]'),
      baseImg: (el.querySelector('[data-shoes-buybox-img]') || {}).src,
      selected: []
    };

    // カラー単独で画像を切り替えるためのマップ
    box.colorIndex = -1;
    box.colorMap = {};
    var cmEl = el.querySelector('[data-shoes-colormap]');
    if (cmEl) {
      try {
        var cm = JSON.parse(cmEl.textContent);
        box.colorIndex = typeof cm.index === 'number' ? cm.index : -1;
        box.colorMap = cm.map || {};
      } catch (e) {}
    }

    box.optionCount = box.fieldsets.length;
    for (var i = 0; i < box.optionCount; i++) box.selected.push(null);

    // 単一バリアント商品は最初から確定させる
    if (box.variants.length === 1) {
      box.selected = (box.variants[0].options || []).slice();
      box.fieldsets.forEach(function (fs, idx) {
        var input = fs.querySelector('input[value="' + cssEscape(box.selected[idx]) + '"]');
        if (input) input.checked = true;
      });
    }

    box.fieldsets.forEach(function (fs) {
      fs.addEventListener('change', function (ev) {
        var input = ev.target;
        if (!input || !input.hasAttribute('data-shoes-option-input')) return;
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        box.selected[idx] = input.value;
        clearError(box);
        sync(box);
        if (state.side === box.side) syncSticky();
      });
    });

    // 未選択のまま送信されたら止める。capture で <product-form> の submit より先に走らせる
    if (box.form) {
      box.form.addEventListener(
        'submit',
        function (ev) {
          var missing = firstMissingIndex(box);
          if (missing === -1 && currentVariant(box)) return;
          ev.preventDefault();
          ev.stopImmediatePropagation();
          showMissing(box, missing === -1 ? 0 : missing);
        },
        true
      );
    }

    sync(box);
    return box;
  }

  function cssEscape(v) {
    return String(v).replace(/"/g, '\\"');
  }

  function firstMissingIndex(box) {
    for (var i = 0; i < box.selected.length; i++) {
      if (!box.selected[i]) return i;
    }
    return -1;
  }

  function currentVariant(box) {
    if (firstMissingIndex(box) !== -1) return null;
    for (var i = 0; i < box.variants.length; i++) {
      var v = box.variants[i];
      var hit = true;
      for (var j = 0; j < box.selected.length; j++) {
        if (v.options[j] !== box.selected[j]) {
          hit = false;
          break;
        }
      }
      if (hit) return v;
    }
    return null;
  }

  // 他の選択を固定したとき、その位置に選べる値の集合
  function availableValues(box, index) {
    var set = {};
    box.variants.forEach(function (v) {
      if (!v.available) return;
      for (var j = 0; j < box.selected.length; j++) {
        if (j === index) continue;
        if (box.selected[j] && v.options[j] !== box.selected[j]) return;
      }
      set[v.options[index]] = true;
    });
    return set;
  }

  function sync(box) {
    box.fieldsets.forEach(function (fs) {
      var idx = parseInt(fs.getAttribute('data-option-index'), 10);
      var avail = availableValues(box, idx);
      var hasAny = Object.keys(avail).length > 0;

      fs.querySelectorAll('[data-shoes-option-input]').forEach(function (input) {
        var ok = !hasAny || !!avail[input.value];
        input.disabled = !ok;
        var label = fs.querySelector('label[for="' + input.id + '"]');
        if (label) {
          label.classList.toggle('is-unavailable', !ok);
          // 見た目だけでなくテキストでも区別する(§8.7)
          var note = label.querySelector('[data-shoes-value-note]');
          if (note) note.textContent = ok ? '' : '（売り切れ）';
        }
      });

      var out = fs.querySelector('[data-shoes-option-selected]');
      if (out) out.textContent = box.selected[idx] ? box.selected[idx] : '未選択';
    });

    var v = currentVariant(box);

    if (v && box.priceEl) box.priceEl.textContent = yen(v.price);

    if (box.stockEl) {
      box.stockEl.textContent = !v ? '' : v.available ? '在庫あり' : '在庫切れ';
    }

    if (box.submitEl) {
      var soldOut = !!v && !v.available;
      box.submitEl.disabled = soldOut;
      if (box.labelEl) {
        box.labelEl.textContent = soldOut
          ? '在庫切れ'
          : box.isPreorder
          ? '予約する'
          : 'カートに入れる';
      }
    }

    if (box.idInput && v) box.idInput.value = v.id;

    syncImage(box, v);
  }

  // 画像はカラーだけで切り替える。サイズの選択を待たない。
  // 優先順: カラーに紐づく画像 → 確定バリアントの画像 → 初期画像
  function syncImage(box, v) {
    if (!box.imgEl) return;

    var color = box.colorIndex >= 0 ? box.selected[box.colorIndex] : null;
    var next = null;

    if (color && box.colorMap[color]) next = box.colorMap[color];
    if (!next && v && v.image) next = v.image;
    if (!next) next = box.baseImg;
    if (!next) return;

    if (box.imgEl.getAttribute('src') === next) return;
    box.imgEl.setAttribute('src', next);
    box.imgEl.removeAttribute('srcset');

    var label = box.title;
    if (color) label += ' ' + color;
    box.imgEl.setAttribute('alt', label);
  }

  function showMissing(box, index) {
    var fs = box.fieldsets[index];
    var name = fs ? fs.querySelector('.shoes-buybox__option-name') : null;
    var label = name ? name.textContent.trim() : 'オプション';
    if (box.errorEl) box.errorEl.textContent = label + 'を選択してください。';
    if (fs) {
      var input = fs.querySelector('[data-shoes-option-input]:not(:disabled)');
      if (input) {
        var lbl = fs.querySelector('label[for="' + input.id + '"]');
        (lbl || input).scrollIntoView({ block: 'center', behavior: prefersReduced() ? 'auto' : 'smooth' });
        input.focus({ preventScroll: true });
      }
    }
    if (stickyError) stickyError.textContent = label + 'を選択してください。';
  }

  function clearError(box) {
    if (box.errorEl) box.errorEl.textContent = '';
    if (stickyError) stickyError.textContent = '';
  }

  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------------- 用途セレクター ---------------- */

  function initUsecase() {
    var nodes = root.querySelectorAll('[data-shoes-usecase]');
    if (!nodes.length) return;
    nodes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var side = btn.getAttribute('data-shoes-usecase');
        nodes.forEach(function (n) {
          var on = n === btn;
          n.classList.toggle('is-selected', on);
          n.classList.toggle('is-dimmed', !on);
          n.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        selectSide(side);
        var target = root.querySelector('[data-shoes-buybox][data-side="' + side + '"]');
        if (target) {
          target.scrollIntoView({ block: 'start', behavior: prefersReduced() ? 'auto' : 'smooth' });
        }
      });
    });
  }

  function selectSide(side) {
    state.side = side;
    boxes.forEach(function (b) {
      b.el.classList.toggle('is-recommended', b.side === side);
    });
    root.querySelectorAll('[data-shoes-board]').forEach(function (el) {
      el.classList.toggle('is-recommended', el.getAttribute('data-shoes-board') === side);
    });
    syncSticky();
  }

  /* ---------------- Sticky Purchase Bar ---------------- */

  var sticky = document.querySelector('[data-shoes-sticky]');
  var stickyLabel = sticky ? sticky.querySelector('[data-shoes-sticky-label]') : null;
  var stickyPrice = sticky ? sticky.querySelector('[data-shoes-sticky-price]') : null;
  var stickyBtn = sticky ? sticky.querySelector('[data-shoes-sticky-cta]') : null;
  var stickyError = sticky ? sticky.querySelector('[data-shoes-sticky-error]') : null;
  var stickyIdleLabel = stickyLabel ? stickyLabel.textContent : '2つから選ぶ';

  function activeBox() {
    if (!state.side) return null;
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].side === state.side) return boxes[i];
    }
    return null;
  }

  function syncSticky() {
    if (!sticky) return;
    var box = activeBox();

    // ボタンの文言は常に「サイズを選ぶ」。状態で変えない。
    // 購入操作は購入カードのボタンが担い、ここはそこへ運ぶ役に徹する。
    if (stickyBtn) {
      stickyBtn.textContent = 'サイズを選ぶ';
      stickyBtn.disabled = false;
    }

    if (!box) {
      if (stickyLabel) stickyLabel.textContent = stickyIdleLabel;
      if (stickyPrice) stickyPrice.textContent = '';
      return;
    }

    // 商品名／選んだ値。まだ選んでいない分は出さない
    var chosen = box.selected.filter(Boolean);
    var label = box.title;
    if (chosen.length) label += '／' + chosen.join('・');
    if (stickyLabel) stickyLabel.textContent = label;

    var v = currentVariant(box);
    if (stickyPrice) stickyPrice.textContent = v ? yen(v.price) : '';
  }

  function initSticky() {
    if (!sticky || !stickyBtn) return;

    stickyBtn.addEventListener('click', function () {
      var box = activeBox();

      // 商品未選択 → 選択エリアへ
      if (!box) {
        var picker = root.querySelector('[data-shoes-usecase-section]') || root.querySelector('[data-shoes-buybox]');
        if (picker) picker.scrollIntoView({ block: 'start', behavior: prefersReduced() ? 'auto' : 'smooth' });
        return;
      }

      // 購入カードへ運び、最初の未選択オプションに合わせる
      box.el.scrollIntoView({ block: 'start', behavior: prefersReduced() ? 'auto' : 'smooth' });
      var missing = firstMissingIndex(box);
      if (missing !== -1) {
        var fs = box.fieldsets[missing];
        var input = fs && fs.querySelector('[data-shoes-option-input]:not(:disabled)');
        if (input) input.focus({ preventScroll: true });
      }
    });

    // 最終CTA / フッターが見えている間は重複を避けて隠す
    // 購入導線が画面にある区間では出さない。
    // ヒーロー(CTA2つ)・購入カード・最終CTA・フッターがその対象。
    var sentinels = [];
    ['.shoes-hero', '.shoes-purchase', '[data-shoes-final]'].forEach(function (sel) {
      var el = root.querySelector(sel);
      if (el) sentinels.push(el);
    });
    var footer = document.querySelector('footer, .f-footer');
    if (footer) sentinels.push(footer);

    var showAfter = parseInt(sticky.getAttribute('data-show-after') || '400', 10);
    var overlapping = 0;

    if ('IntersectionObserver' in window && sentinels.length) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            overlapping += entry.isIntersecting ? 1 : -1;
          });
          if (overlapping < 0) overlapping = 0;
          update();
        },
        { threshold: 0.01 }
      );
      sentinels.forEach(function (s) {
        io.observe(s);
      });
    }

    function update() {
      var scrolled = (window.pageYOffset || document.documentElement.scrollTop) > showAfter;
      var visible = scrolled && overlapping === 0;
      sticky.toggleAttribute('hidden', !visible);
      // 画面下に浮遊要素を2つ並べない
      document.body.classList.toggle('shoes-sticky-on', visible);
    }

    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      },
      { passive: true }
    );

    update();
  }

  /* ---------------- カート追加の結果表示 ---------------- */

  function initCartFeedback() {
    document.addEventListener('product-ajax:added', function () {
      boxes.forEach(function (b) {
        if (b.errorEl) b.errorEl.textContent = '';
      });
      if (stickyError) stickyError.textContent = '';
    });

    document.addEventListener('product-ajax:error', function (ev) {
      var msg = (ev.detail && ev.detail.errorMessage) || 'カートに追加できませんでした。';
      var box = activeBox() || boxes[0];
      if (box && box.errorEl) box.errorEl.textContent = msg;
      if (stickyError) stickyError.textContent = msg;
    });
  }

  /* ---------------- 起動 ---------------- */

  root.querySelectorAll('[data-shoes-buybox]').forEach(function (el) {
    boxes.push(createBox(el));
  });

  // 見ているボードに合わせて下部バーの対象商品を切り替える。
  // ボード下のCTAを外したので、購入導線はここが担う。
  function initBoardContext() {
    var boards = Array.prototype.slice.call(root.querySelectorAll('[data-shoes-board]'));
    if (!boards.length || !('IntersectionObserver' in window)) return;

    var ratios = {};
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          ratios[e.target.getAttribute('data-shoes-board')] = e.isIntersecting ? e.intersectionRatio : 0;
        });
        var best = null;
        var bestRatio = 0.25; // 画面の1/4以上を占めている側だけを採用する
        Object.keys(ratios).forEach(function (k) {
          if (ratios[k] > bestRatio) {
            bestRatio = ratios[k];
            best = k;
          }
        });
        if (best && best !== state.side) selectSide(best);
      },
      { threshold: [0, 0.25, 0.5, 0.75, 1] }
    );
    boards.forEach(function (b) {
      io.observe(b);
    });
  }

  // 適用条件のモーダル。native <dialog> なのでフォーカス移動とESCは標準任せ。
  function initTerms() {
    var dlg = root.querySelector('[data-shoes-terms]');
    if (!dlg) return;

    root.querySelectorAll('[data-shoes-terms-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (typeof dlg.showModal === 'function') dlg.showModal();
        else dlg.setAttribute('open', '');
      });
    });

    dlg.querySelectorAll('[data-shoes-terms-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        dlg.close();
      });
    });

    // 背景クリックで閉じる。dialog自身がバックドロップなので座標で判定する
    dlg.addEventListener('click', function (ev) {
      if (ev.target !== dlg) return;
      var r = dlg.getBoundingClientRect();
      var inside =
        ev.clientX >= r.left && ev.clientX <= r.right && ev.clientY >= r.top && ev.clientY <= r.bottom;
      if (!inside) dlg.close();
    });
  }

  initTerms();
  initUsecase();
  initBoardContext();
  initSticky();
  initCartFeedback();
  syncSticky();
})();
